import React, {useEffect} from "react";
import _ from "../Trans";
import ReactGA from "react-ga4";
import Config from "../Config";

export default function TC() {
    const supermanagerIframeTcUrl = process.env.REACT_APP_PUBLIC_URL + '/tc-react/'

    useEffect(() => {
        const rulesTitle = _('T&C')
        ReactGA.initialize(Config.GA_CODE);
        ReactGA.send({hitType: "pageview", page: "/tc/", title: rulesTitle});
    }, []);

    return (
        <iframe src={supermanagerIframeTcUrl}
                title="T&C"
                className="mb-5 pb-5 w-100 h-100 rules"
        >
        </iframe>
    )
}